import $ from "jquery";
import {AJAX} from "./ajax";

$(function () {
  var targets = [];

  const $body = $("body");
  $body.tooltip({
    selector: "[data-toggle='tooltip']",
    container: "body"
  });

  $body.on("show.bs.tooltip", function($evt) {
    targets.push($evt.target);
  });

  $body.on("hide.bs.tooltip", function($evt) {
    targets = targets.filter(function(t) { return t !== $evt.target; });
  });

  AJAX.onRequest(function() {
    $(targets).tooltip("hide");
  });

  {
    const origFns = {
      remove: $.fn.remove,
      detach: $.fn.detach,
      replaceWith: $.fn.replaceWith
    };

    Object.keys(origFns).forEach(function (key) {
      $.fn[key] = function () {
        targets.slice().forEach(t => {
          this.each(function (i, el) {
            if ($.contains(el, t)) $(t).tooltip("hide");
          });
        });

        return origFns[key].apply(this, arguments);
      };
    });
  }

  {
    class BatchScheduler {
      constructor(fn) {
        this.items = [];
        this.scheduled = false;
        this.perform = () => {
          this.items.forEach(fn);
          this.items = [];
          this.scheduled = false;
        };
      }

      add(item) {
        if(this.items.indexOf(item) === -1) {
          this.items.push(item);
          if(!this.scheduled) {
            this.scheduled = true;
            setTimeout(this.perform, 0);
          }
        }
      }
    }

    const origFns = {
      addClass: $.fn.addClass,
      removeClass: $.fn.removeClass,
      toggleClass: $.fn.toggleClass
    };
    
    let passthrough = false;

    const scheduler = new BatchScheduler(t => {
      const $t = $(t);
      if (!$t.is(":visible")) {
        passthrough = true;
        $t.tooltip("hide");
        passthrough = false;
      }
    });

    Object.keys(origFns).forEach(function (key) {
      $.fn[key] = function () {
        var ret = origFns[key].apply(this, arguments);

        if(!passthrough) targets.forEach(t => scheduler.add(t));

        return ret;
      };
    });
  }
});
